import styled, { createGlobalStyle } from 'styled-components';

export const DrawerBody = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CompletedUsersNotice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 28px;
  border-radius: 3px;
  padding: 7px 8px;
  background: var(--content-quiz-30, #c1d8f84d);
  color: var(--analytics-blue, #3e6496);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 14px;
  letter-spacing: 0;
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px;
  color: var(--black-darkest, #111a27);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 20px;
  font-weight: 900;
  line-height: 26px;
`;

export const PlaylistDurationText = styled.p`
  margin: 0;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  span {
    color: var(--black-dark, #1a2535);
    font-family: var(--font-family-base), Lato, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`;

export const PlaylistDurationRefreshingText = styled.p`
  margin: 6px 0 0;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptionCard = styled.div<{ $selected: boolean; $disabled?: boolean }>`
  border: 2px solid ${({ $selected }) => ($selected ? 'var(--chetwode-blue)' : 'transparent')};
  border-radius: 12px;
  padding: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  background: ${({ $selected }) => ($selected ? 'var(--fog-15)' : 'var(--grey-lighter-50)')};
  transition: border-color 0.18s ease, background-color 0.18s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:hover {
    border-color: ${({ $selected }) =>
      $selected ? 'var(--chetwode-blue)' : 'var(--grey-lighter)'};
  }
`;

export const OptionTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const RadioDot = styled.div<{ $selected: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  border: 2px solid ${({ $selected }) => ($selected ? '#9f87ff' : '#e0deea')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  background: #ffffff;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ $selected }) => ($selected ? '#9f87ff' : 'transparent')};
  }
`;

export const OptionTextBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const OptionLabel = styled.div`
  color: var(--black-dark, #1a2535);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: 23px;
  word-wrap: break-word;
`;

export const OptionSubtitle = styled.div`
  margin-top: 4px;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`;

export const TrainingPaceControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 188px;
  height: 42px;
  gap: 8px;
  white-space: nowrap;
`;

export const TrainingPacePill = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  width: 106px;
  height: 42px;
  padding: 3px 8px;
  border-radius: 10px;
  background: var(--grey-lighter, #f2f2f7);
  box-sizing: border-box;
  flex: 0 0 106px;
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  line-height: 14px;
`;

export const PaceLabel = styled.span`
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
  flex: 0 0 auto;
`;

export const PaceValue = styled.span`
  min-width: 0;
  color: var(--black-darkest, #111a27);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  margin-right: 4px;
`;

export const PaceButtonsCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  width: 16px;
  height: 36px;
  margin: 0 2px;
`;

export const PaceButton = styled.button`
  position: relative;
  width: 10px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--lilac, #9f87ff);
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child::after {
    content: '';
    position: absolute;
    top: -12px;
    right: -3px;
    bottom: 1px;
    left: -3px;
  }

  &:last-child::after {
    content: '';
    position: absolute;
    top: 0;
    right: -3px;
    bottom: -10px;
    left: -3px;
  }

  &:focus-visible {
    outline: 1px solid #9f87ff;
  }

  svg {
    width: auto;
    height: auto;
  }
`;

export const PaceUnit = styled.span`
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  flex: 0 0 auto;
`;

export const RecommendedExpanded = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e2ddec;
`;

export const RecommendedLoadingNotice = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e2ddec;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

export const InlineSpinnerContainer = styled.span`
  width: 14px;
  height: 14px;
  position: relative;
  flex: 0 0 14px;

  > div {
    position: relative;
    width: 14px;
    height: 14px;
    left: 0;
    top: 0;
    transform: none;
  }
`;

export const DeadlineResultBox = styled.div`
  text-align: center;
`;

export const DeadlineResultDate = styled.div`
  color: #1f2b3d;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 6px;
`;

export const DeadlineResultMeta = styled.div`
  color: #5f6472;
  font-size: 12px;
  line-height: 1.45;

  span {
    color: #1f2b3d;
    font-weight: 700;
  }
`;

export const CustomDateHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CustomDateSummary = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CustomDateExpanded = styled.div`
  margin-top: 14px;
  padding-top: 16px;
  border-top: 1px solid #e2ddec;
  display: flex;
  justify-content: center;
`;

export const CustomDateMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  color: #5f6472;
  font-size: 14px;
  line-height: 1.45;
  text-align: center;

  strong {
    color: #1f2b3d;
    font-weight: 700;
  }
`;

export const StyledDatePicker = styled.div`
  width: 184px;
  min-width: 184px;

  .ant-picker {
    width: 100%;
    min-height: 50px;
    padding: 0 16px;
    border-radius: 14px;
    border: 0;
    background: #f2f2f7;
    box-shadow: none;
  }

  .ant-picker-input {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 12px;
  }

  .ant-picker-input > input {
    color: #1f2b3d;
    font-size: 15px;
    font-weight: 700;
  }

  .ant-picker-suffix {
    margin-left: 0;
    color: #7965c6;
    display: inline-flex;
    align-items: center;
  }

  .ant-picker-clear {
    color: #8d86a3;
  }

  .ant-picker:hover,
  .ant-picker-focused,
  .ant-picker.ant-picker-focused {
    border-color: transparent;
    box-shadow: none;
  }

  @media (max-width: 720px) {
    width: 100%;
    min-width: 0;
  }
`;

export const PastDateWarning = styled.div`
  color: #b26a1d;
  font-size: 13px;
  line-height: 1.45;
  text-align: center;
`;

export const FooterActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    min-width: 180px;
    min-height: 52px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const ManageDeadlineModalGlobalStyles = createGlobalStyle`
  .manage-deadline-modal .ant-modal {
    width: 595px !important;
    max-width: 595px;
  }

  .manage-deadline-modal .ant-modal-content {
    border-radius: 20px;
    overflow: hidden;
    min-height: 601px;
    height: auto;
  }

  .manage-deadline-modal .ant-modal-body > div > div:first-child {
    height: 112px;
    padding: 30px;
    justify-content: center;
    align-items: center;
  }

  .manage-deadline-modal .ant-modal-body > div > div:nth-child(2) {
    padding: 40px 0 20px;
  }

  .manage-deadline-modal .ant-modal-body > div > div:nth-child(3) {
    padding: 0 30px 30px;
    justify-content: flex-end;
  }

  .manage-deadline-modal .ant-modal-close {
    top: 30px;
    right: 30px;
  }
`;
